export default __webpack_public_path__ + "static/media/owl.a70170c8.svg";